import ApiClient from "@/api/ApiClient.ts";

const state = {
  calls: [],
};

const mutations = {
  setCalls(state, calls) {
    state.calls.splice(0, state.calls.length);
    state.calls.push(...calls);
  },
};

const actions = {
  async getCalls({ commit }, paramsToSend) {
    const params = {
      ...paramsToSend,
    };
    const api = ApiClient();
    const { data } = await api.get("/calls", { params });
    commit("setCalls", data);
  },
};

const getters = {
  calls(state) {
    return state.calls;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
